/**
 * Sound Effects System for Nightclub
 * Self-contained sound effects with Web Audio API
 */

class SoundFX {
  constructor() {
    this.audioContext = null;
    this.enabled = true;
  }
  
  getContext() {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    return this.audioContext;
  }
  
  playTone(frequency, duration = 0.1, type = 'sine', volume = 0.3) {
    if (!this.enabled) return;
    try {
      const ctx = this.getContext();
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.frequency.value = frequency;
      oscillator.type = type;
      gainNode.gain.setValueAtTime(volume, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration);
      
      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + duration);
    } catch (e) {
      // Audio not supported
    }
  }
  
  click() {
    this.playTone(800, 0.05, 'square', 0.1);
  }
  
  hover() {
    this.playTone(600, 0.03, 'sine', 0.05);
  }
  
  success() {
    this.playTone(523, 0.1, 'sine', 0.2);
    setTimeout(() => this.playTone(659, 0.1, 'sine', 0.2), 100);
    setTimeout(() => this.playTone(784, 0.15, 'sine', 0.2), 200);
  }
  
  error() {
    this.playTone(200, 0.2, 'sawtooth', 0.15);
  }
  
  chatSend() {
    this.playTone(880, 0.05, 'sine', 0.1);
  }
  
  chatReceive() {
    this.playTone(440, 0.08, 'sine', 0.08);
  }
  
  emote() {
    this.playTone(660, 0.1, 'sine', 0.15);
    setTimeout(() => this.playTone(880, 0.1, 'sine', 0.15), 80);
  }
  
  footstep() {
    this.playTone(100 + Math.random() * 50, 0.05, 'sine', 0.03);
  }
  
  doorOpen() {
    this.playTone(300, 0.15, 'sine', 0.1);
    setTimeout(() => this.playTone(400, 0.1, 'sine', 0.1), 100);
  }
  
  doorLocked() {
    this.playTone(150, 0.2, 'square', 0.1);
    setTimeout(() => this.playTone(100, 0.2, 'square', 0.1), 150);
  }
  
  vipEntry() {
    this.playTone(523, 0.15, 'sine', 0.2);
    setTimeout(() => this.playTone(659, 0.15, 'sine', 0.2), 100);
    setTimeout(() => this.playTone(784, 0.15, 'sine', 0.2), 200);
    setTimeout(() => this.playTone(1047, 0.25, 'sine', 0.25), 300);
  }
  
  gift() {
    this.playTone(880, 0.1, 'sine', 0.2);
    setTimeout(() => this.playTone(1100, 0.1, 'sine', 0.2), 80);
    setTimeout(() => this.playTone(1320, 0.15, 'sine', 0.2), 160);
  }
  
  coins() {
    for (let i = 0; i < 4; i++) {
      setTimeout(() => this.playTone(1200 + i * 200, 0.05, 'sine', 0.1), i * 50);
    }
  }
  
  questComplete() {
    this.playTone(523, 0.1, 'sine', 0.2);
    setTimeout(() => this.playTone(659, 0.1, 'sine', 0.2), 100);
    setTimeout(() => this.playTone(784, 0.1, 'sine', 0.2), 200);
    setTimeout(() => this.playTone(1047, 0.3, 'sine', 0.3), 300);
  }
  
  elevator() {
    this.playTone(200, 0.3, 'sine', 0.1);
    setTimeout(() => this.playTone(300, 0.3, 'sine', 0.1), 200);
    setTimeout(() => this.playTone(400, 0.4, 'sine', 0.15), 400);
  }
}

// Export singleton instance
export const soundFX = new SoundFX();
export default soundFX;
